import { LoginComponent } from './login/login.component';
export { LoginComponent }

export const COMPONENTS = [
  LoginComponent
];
